<script>
	// import { flights } from './data.js';

	let flights = [];
	fetch("https://vda-lab.github.io/assets/svelte-flights.json")
		.then(res => res.json())
		.then(data => flights = data.slice(1,10000))

	let slider_value = 5000;

	const rescale = function(x, domain_min, domain_max, range_min, range_max) {
		return ((range_max - range_min)*(x-domain_min))/(domain_max-domain_min) + range_min
	}

	const scaleLong = function(x) {
		return rescale(x, -180, 180, 0, 800)
	}
	
	const scaleLat = function(x) {
		return rescale(x, 90, -90, 0, 400)
	}
	
	const scaleDist = function(x) {
		return rescale(x, 1, 15406, 2, 10)
	}

</script>

<style>
	circle {
		opacity: 0.5;
		fill: blue;
	}
	circle.international {
		fill: red;
	}
	circle.hidden {
		opacity: 0.05;
	}
	line {
		stroke-width: 3;
		stroke: black;
	}
</style>

<h1>Airport flights data</h1>
<div>
(sample of 10,000 flights)<br/>
Airports serving flights in this range (km): {slider_value - 500} - {slider_value + 500} <br/>
<input type="range" min="1" max="15406" bind:value={slider_value} class="slider" id="myRange" /><br/>
Which is about this far:
</div>
<svg width=1000 height=20>
	<line x1=10 y1=10 x2={10+rescale(slider_value,0,40000,0,800)} y2=10 />
</svg>

<svg width=1000 height=500>
{#each flights as flight}
	<circle r={scaleDist(flight.distance)}
			cx={scaleLong(flight.from_long)}
			cy={scaleLat(flight.from_lat)}
			class:international="{flight.from_country != flight.to_country}"
			class:hidden="{Math.abs(flight.distance - slider_value) > 500}">
		<title>{flight.from_airport}</title>
	</circle>
{/each}
</svg>